import * as React from 'react';

type TransformFormatListItemProps = {
    className: string,
    item: {
        value: string,
        label: string,
        disabled: boolean,
    },
};

export function TransformFormatListItem({ item, className }: TransformFormatListItemProps) {
    return <div
        key={item.value}
        className={`${className} ${item.disabled ? 'disabled' : ''}`}>
        {item.label}
    </div>;
}